module.exports = __webpack_public_path__ + "MaterialIcons-Regular.012cf6a10129e2275d79.woff";


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/node_modules/material-design-icons/iconfont/MaterialIcons-Regular.woff
// module id = ../../../../material-design-icons/iconfont/MaterialIcons-Regular.woff
// module chunks = styles